import jscAdd from 'ehogan-loader/jscmanager';

import CaptchaInput from 'source/lib/component/input/captcha';
import ErrorMessageBlock from 'source/lib/component/block/error_message';
import ExternalAuthButton from 'source/lib/component/button/external_auth';
import EulaInput from 'source/lib/component/input/eula';
import LoginInfoBlock from 'source/lib/component/block/login_info';
import LoginInput from 'source/lib/component/input/login';
import FingerprintInput from 'source/lib/component/input/fingerprint';
import NameInput from 'source/lib/component/input/name';
import PasswordInput from 'source/lib/component/input/password';
import RememberInput from 'source/lib/component/input/remember';
import SubmitButton from 'source/lib/component/button/submit';
import TwoFactorInput from 'source/lib/component/input/twofactor';
import TwoFactorTimer from 'source/lib/component/block/twofactor_timer';
import Dropdown from 'source/lib/component/dropdown';

jscAdd([
    CaptchaInput,
    ErrorMessageBlock,
    ExternalAuthButton,
    EulaInput,
    LoginInfoBlock,
    LoginInput,
    FingerprintInput,
    NameInput,
    PasswordInput,
    RememberInput,
    Dropdown,
    SubmitButton,
    TwoFactorInput,
    TwoFactorTimer
]);

export {
    CaptchaInput,
    ErrorMessageBlock,
    ExternalAuthButton,
    EulaInput,
    LoginInfoBlock,
    LoginInput,
    FingerprintInput,
    NameInput,
    PasswordInput,
    RememberInput,
    Dropdown,
    SubmitButton,
    TwoFactorInput,
    TwoFactorTimer
};
